import { processSteps } from "../data/homepageData";

export default function ProcessSection() {
  return (
    <section className="rz-section rz-section--dark" id="proces">
      <div className="rz-shell">
        <div className="rz-section-heading">
          <p className="rz-kicker">Proces</p>
          <h2>Cum implementăm Rezervix pentru businessul tău</h2>
        </div>

        <div className="rz-steps">
          {processSteps.map((step, index) => (
            <article key={step.title} className="rz-step-card rz-service-card">
              <div className="rz-step-card__index">0{index + 1}</div>
              <h3 className="rz-step-card__title">{step.title}</h3>
              <p className="rz-step-card__text">{step.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
